import React from 'react';
import { ArrowDropDown } from '@mummssoftware/icons';

var _ref = /*#__PURE__*/React.createElement(ArrowDropDown, null);

export const DropdownIndicator = () => _ref;